import type { FaireProductEntity } from "../../entity_types/product";

export const p_bo171cwo8b: FaireProductEntity = {
  token: "p_bo171cwo8b",
  type: "product",
  name: "The Original Japanese Barbecue Sauce, 17oz",
  brandToken: "b_6ke73bi5cu",
  brandName: "Bachan's",
  imageUrl:
    "https://cdn.faire.com/fastly/7325aa5d0b35eddd7419db974fd4c9988bda6a27ffaddd0742135078e9894e1b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/97ccbc00fe6a943bf5382662a6f7d9a0b3d977bca0b401c2416ef3124656b20f.jpeg",
    "https://cdn.faire.com/fastly/f7067605ea6e1312b45fe72ab789650e126a3f3c18e196e5e5c36a7163de2619.jpeg",
    "https://cdn.faire.com/fastly/f7b917803082a9ed191845a5a7cd9643cdcb82191c40eba900a78ac4bbeb6bd5.jpeg",
    "https://cdn.faire.com/fastly/e8bbff7f8607add467b72da9fac00763f0c8a568c82950493e93bd0e251ddf81.jpeg",
    "https://cdn.faire.com/fastly/2175cfe14ee158d62dec40fdaf3d52b805292b48c978881868d8993d6c0abb17.jpeg",
    "https://cdn.faire.com/fastly/547f1e0b20ebebe880e5b7b622e16210c34e4edcf1ac0205434b46cafd2ef150.jpeg",
  ],
  priceDollars: 6,
  description:
    "Great as a sauce or marinade on meat, fish, veggies, rice & anything in-between.\n\nOur Original Japanese Barbecue Sauce is everything. It’s teriyaki-ish. Umami-full. Rich, bold and so authentic, it should be notarized. It’s a deeply savory-sweet recipe of soy, mirin, ginger, garlic and green onion. It’s the one that started it all. The legend. The O.G. Our crave-worthy flavor always comes from simple, clean ingredients. Let's eat! Itadakimasu!",
  tags: [],
  msrpDollars: 9.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:16:53.869Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
